import React, { useEffect, useState } from 'react';
import style from '../css/Booking.module.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import HeaderBar from '../components/HeaderBar';
import { FaHome } from 'react-icons/fa';

function Booking() {
	const [formData, setFormData] = useState({
		name: '',
		phone: '',
		email: '',
		location: '',
		service: '',
		message: '',
	});
	const [addresses, setAddresses] = useState([]);
	const [city, setCIty] = useState('');
	const [loading, setLoading] = useState(false);
	const [responseMsg, setResponseMsg] = useState('');
	const [user, setUser] = useState(null);

	const navigate = useNavigate();

	// Fetch user and address on mount
	useEffect(() => {
		const storedUser = JSON.parse(localStorage.getItem('user'));
		if (!storedUser?.id) {
			navigate('/');
			return;
		}
		setUser(storedUser);
		setFormData((prev) => ({
			...prev,
			name: storedUser.name,
			phone: storedUser.phone,
			email: storedUser.email,
		}));
		fetchAddresses(storedUser.id);
	}, [navigate]);

	// Fetch user's saved addresses
	const fetchAddresses = async (userId) => {
		try {
			const res = await axios.post(
				'https://hometech-repairs.in/customerDB/get_address.php',
				{ profile_id: userId }
			);
			if (res.data.status) {
				setAddresses(res.data.data);
			}
		} catch (err) {
			console.error('Error fetching addresses:', err);
		}
	};

	// Handle input change
	const handleChange = (e) => {
		setResponseMsg('');
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleChangeAddress = (e) => {
		setResponseMsg('');
		const { name, value } = e.target;

		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	// Handle form submission
	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setResponseMsg('');

		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/NewBooking.php',
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ ...formData, profile_id: user.id }),
				}
			);
			const result = await response.json();

			if (result.status) {
				setResponseMsg('Your inquiry has been submitted successfully!');
				setFormData({
					name: user.name,
					phone: user.phone,
					email: user.email,
					location: '',
					service: '',
					message: '',
				});
			} else {
				setResponseMsg('Failed to submit. Please try again.');
			}
		} catch (error) {
			setResponseMsg(
				'Error submitting form. Please check your internet connection.'
			);
		}
		setLoading(false);
	};

	return (
		<div>
			<HeaderBar
				text={'New Booking'}
				icon={<FaHome color="black" size={20} />}
				navi="/dashboard"
			/>
			<div className={style.container}>
				{/* <p className={style.subtitle}>Book your appointment here.</p> */}

				<form className={style.form} onSubmit={handleSubmit}>
					<div className={style.row}>
						<input
							type="text"
							name="name"
							placeholder="Name *"
							className={style.input}
							value={formData.name}
							onChange={handleChange}
							required
						/>
						<input
							type="text"
							name="phone"
							placeholder="Phone Number *"
							className={style.input}
							value={formData.phone}
							onChange={handleChange}
							required
						/>
					</div>

					<input
						type="email"
						name="email"
						placeholder="Email *"
						className={style.input}
						value={formData.email}
						onChange={handleChange}
						required
					/>

					{/* Location Dropdown - populated from user's addresses */}
					<select
						name="location"
						className={style.input}
						value={formData.location}
						onChange={handleChangeAddress}
						required
					>
						<option value="">Select Location *</option>
						{addresses.map((addr, index) => (
							<option
								key={index}
								value={`${addr.street}, ${addr.town}, ${addr.city}, ${addr.pincode} (${addr.address_type})`}
							>
								{`${addr.street}, ${addr.town}, ${addr.city}, ${addr.pincode} (${addr.address_type})`}
							</option>
						))}
					</select>

					<p style={{ margin: '10px 0' }}>
						Don't see your address?{' '}
						<span
							style={{
								color: '#007bff',
								cursor: 'pointer',
								textDecoration: 'underline',
							}}
							onClick={() => navigate('/your-address')}
						>
							Add New Address
						</span>
					</p>
					{/* Service Dropdown */}
					<select
						name="city"
						className={style.input}
						value={city}
						onChange={(e) => setCIty(e.target.value)}
						required
					>
						<option value="">Select City *</option>
						<option value="Bangalore">Bangalore</option>
						<option value="Dhanbad">Dhanbad</option>
					</select>

					<select
						name="service"
						className={style.input}
						value={formData.service}
						onChange={handleChange}
						required
					>
						<option value="">Select Service *</option>
						<option value="Washing Machine Repairs">
							Washing Machine Repairs
						</option>
						<option value="Refrigerator Repair Services">
							Refrigerator Repair Services
						</option>
						<option value="Air Conditioner (AC) Repairs">
							Air Conditioner (AC) Repairs
						</option>
						<option value="Microwave Oven Repairs">
							Microwave Oven Repairs
						</option>
						<option value="TV Repairs">TV Repairs</option>
						<option value="Cooler Repairs">Cooler Repairs</option>
						<option value="Dish Washer Repairs">Dish Washer Repairs</option>

						{/* Additional options for Bangalore only */}
						{city === 'Bangalore' && (
							<>
								<option value="Water Purifier Repairs">
									Water Purifier Repairs
								</option>
								<option value="UPS Repairs">UPS Repairs</option>
								<option value="Solar Water Heater Repairs">
									Solar Water Heater Repairs
								</option>
								<option value="Chimney Repairs">Chimney Repairs</option>
								<option value="Electric Water Heater Repairs">
									Electric Water Heater Repairs
								</option>
								<option value="Gas Water Heater Repairs">
									Gas Water Heater Repairs
								</option>
							</>
						)}
					</select>

					<textarea
						name="message"
						placeholder="Your Message"
						rows="4"
						className={style.textarea}
						value={formData.message}
						onChange={handleChange}
					></textarea>

					<button
						type="submit"
						className={style.button}
						style={{ width: 120 }}
						disabled={loading}
					>
						{loading ? 'Submitting...' : 'Submit'}
					</button>

					{responseMsg && <p className={style.response}>{responseMsg}</p>}
				</form>
			</div>
		</div>
	);
}

export default Booking;
